// extracted by mini-css-extract-plugin
module.exports = {"logo-WHITE":"logo_logo-WHITE__3BVYy","logo-BLUE":"logo_logo-BLUE__wUUFL"};